// extracted by mini-css-extract-plugin
module.exports = {"news_row":"NewsRow_news_row__hcxw4"};